import { useTranslation } from "react-i18next";
import { Location } from "iconsax-react";
import type { AddressesSection as AddressesSectionType } from "../../types/personalSheet";
import ProfileDataRow from "../ProfileDataRow";

interface Props {
  addresses: AddressesSectionType | null;
}

export default function AddressesSection({ addresses }: Props) {
  const { t } = useTranslation("EmployeePortal");

  if (!addresses) {
    return <p className="text-body-regular-md content-base-secondary">{t("personalSheet.empty.addresses")}</p>;
  }

  return (
    <div className="flex flex-col">
      <ProfileDataRow icon={Location} label={t("personalSheet.fields.addressRegistration")} value={addresses.address_registration} />
      <ProfileDataRow icon={Location} label={t("personalSheet.fields.addressFactual")} value={addresses.address_factual} />
    </div>
  );
}
